import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { identityActions } from '@figure/frontlib-onboarding-redux';
import { isLocalhost } from 'shared/utils';
import { useRedux, useRedirect } from 'shared/hooks';
import PageRoute from './PageRoute';

/**
 * Container for a page (screen) route for handling authenticated vs unsecured screens as well as overriding the route
 * context.
 */
const PageRouteContainer = ({ unsecured, ...rest }) => {
  const { jwt, logout } = useRedux('identityReducer', identityActions);
  const { redirectToLocation } = useRedirect();
  const isAuthenticated = jwt?.length > 0;

  const handleLogout = () => {
    logout();
    window.location.reload();
  };

  // For secured (default) routes, if unauthenticated, redirect to login
  useEffect(() => {
    if (!unsecured && !isAuthenticated) {
      const location = isLocalhost() ? '/applications/start' : process.env.REACT_APP_LOGIN_PATH;

      redirectToLocation(location, true);
    }
  }, [unsecured, isAuthenticated, redirectToLocation]);

  return <PageRoute isAuthenticated={isAuthenticated} onLogout={handleLogout} {...rest} />;
};

PageRouteContainer.propTypes = {
  /**
   * If unsecured = false, the page will require authentication and will redirect if not authenticated.
   */
  unsecured: PropTypes.bool,
};

PageRouteContainer.defaultProps = {
  unsecured: false,
};

export default PageRouteContainer;
